
import { useLocale } from "next-intl";

export default function PropertyDetailsSkeleton() {
  const locale = useLocale();
  const isArabic = locale === "ar";

  return (
    <div className={`w-full ${isArabic ? "rtl" : "ltr"}`}>
      <div className="mx-auto py-8 animate-pulse">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* LEFT — main image + thumbnails */}
          <div className="space-y-4">
            {/* Main Image */}
            <div className="relative w-full h-[500px] rounded-2xl bg-gray-200"></div>

            {/* Thumbnails */}
            <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5 gap-3">
              {Array.from({ length: 5 }).map((_, i) => (
                <div
                  key={i}
                  className="w-full h-20 lg:h-24 rounded-xl bg-gray-200"
                ></div>
              ))}
            </div>
          </div>

          {/* RIGHT — details */}
          <div className="bg-white rounded-2xl space-y-6 p-4 lg:p-6">
            {/* Title + Price */}
            <div className="flex flex-col xm:flex-row xm:items-center xm:justify-between gap-3 border-b border-b-gray-300 py-3">
              <div className="h-6 w-48 bg-gray-200 rounded"></div>
              <div className="flex items-center gap-2">
                <div className="h-6 w-32 bg-gray-200 rounded"></div>
                <div className="h-5 w-5 bg-gray-200 rounded-full"></div>
              </div>
            </div>

            {/* Location + Type */}
            <div className="flex flex-col xm:flex-row xm:items-center xm:justify-between gap-3 border-b border-b-gray-300 pb-3">
              <div className="flex items-center gap-2">
                <div className="h-5 w-5 rounded-full bg-gray-200"></div>
                <div className="h-5 w-32 bg-gray-200 rounded"></div>
              </div>
              <div className="h-5 w-28 bg-gray-200 rounded"></div>
            </div>

            {/* Description */}
            <div className="space-y-3">
              <div className="h-4 w-full bg-gray-200 rounded"></div>
              <div className="h-4 w-5/6 bg-gray-200 rounded"></div>
              <div className="h-4 w-4/6 bg-gray-200 rounded"></div>
            </div>

            {/* Book Now button */}
            <div className="w-40 h-12 bg-gray-200 rounded-xl mx-auto"></div>
          </div>
        </div>

        {/* Property Features Skeleton */}
        <div className="mt-10 space-y-5">
          {/* Feature title */}
          <div className="h-6 w-40 bg-gray-200 rounded"></div>

          {/* Features grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="h-20 rounded-xl bg-gray-200"></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
